import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import moment from 'moment';

import { sortFn } from '@/helpers';
import { ui } from '@/constants';
import { FormField } from '@/models';

const DATETIME_FORMAT = 'h:mma';

interface FormattedDate {
  formatted: string;
  value: string;
}

@Component({
  name: 'CmgCheckoutPickupTimes',
})
export default class CmgCheckoutPickupTimes extends Vue {
  readonly moreTimesPlaceholder = 'More Times';

  shouldShowMoreTimesPlaceholder = true;
  allowPreselectedTime: boolean = true;
  timesWatcher?: () => void;

  mounted() {
    this.timesWatcher = this.$appStore.watch(state => state.checkout.pickup.availablePickupTimes, this.preselectTime);
  }

  destroyed() {
    if (this.timesWatcher) {
      this.timesWatcher();
    }
  }

  get isSputLoading(): boolean {
    return this.$appStore.state.ui.loaders.pickupTimes > 0;
  }

  get selectedTime(): FormField {
    return this.$appStore.state.checkout.pickup.pickupTime;
  }

  get times(): string[] {
    return this.$appStore.state.checkout.pickup.availablePickupTimes;
  }

  get sortedTimes(): FormattedDate[] {
    return this.times.sort(sortFn(t => t)).map(t => {
      const m = moment(t);

      return { value: t, formatted: m.format(DATETIME_FORMAT) };
    });
  }

  get fastestTimes(): FormattedDate[] {
    return this.sortedTimes.slice(0, this.numVisibleFastestTimes);
  }

  get moreTimes(): FormattedDate[] {
    return this.sortedTimes.slice(this.numVisibleFastestTimes);
  }

  get numVisibleFastestTimes(): number {
    if (this.isLargeView) {
      return 5;
    } else {
      return 3;
    }
  }

  get shouldShowMoreTimes(): boolean {
    return this.sortedTimes.length > this.numVisibleFastestTimes;
  }

  get isLargeView(): boolean {
    return this.$appStore.state.ui.clientWidth > ui.breakpoints.tablet;
  }

  get isVerySmallView(): boolean {
    return this.$appStore.state.ui.clientWidth < ui.breakpoints.phoneXsMax;
  }

  get isSelectedTimeFromMoreTimes(): boolean {
    return !!(this.selectedTime && this.moreTimes.find(t => t.value == this.selectedTime!.value));
  }

  get error(): string | null {
    return this.selectedTime.error;
  }

  onDisallowPreselectedTime() {
    this.allowPreselectedTime = false;
  }

  onSelectTime(time: string) {
    this.$emit('time-selected', time);

    if (this.isSelectedTimeFromMoreTimes) {
      this.shouldShowMoreTimesPlaceholder = false;
    } else {
      this.shouldShowMoreTimesPlaceholder = true;
    }
  }

  isSelectedTime(time: FormField) {
    return this.selectedTime.value == time.value;
  }

  onFocusMoreTimes() {
    this.shouldShowMoreTimesPlaceholder = false;
  }

  onBlurMoreTimes() {
    this.shouldShowMoreTimesPlaceholder = true;
  }

  preselectTime() {
    if (this.allowPreselectedTime) {
      const fastestTimes = this.fastestTimes;
      if (fastestTimes.length > 0) {
        const preSelectedTime = fastestTimes[0].value;
        this.$emit('time-selected', preSelectedTime, false);
      }  
    } else {
      this.$emit('time-selected', '', true);
    }
  }
}
